"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5761],{

/***/ 5761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ItemList; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-a75c1d35.mjs
var app_a75c1d35 = __webpack_require__(3406);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Icon-3122c134.mjs
var Icon_3122c134 = __webpack_require__(3355);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-479ac100.mjs
var Link_479ac100 = __webpack_require__(965);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/ItemList.js






const I = "itemList", g = "itemList__content", x = "itemList__container", C = "itemList__heading", k = "itemList__items", b = "itemList__item", D = "itemList--definition", v = "itemList__item__content", T = "itemList__bullet", h = "itemList--unordered", H = "itemList__bullet--box", P = "itemList__bullet--diamond", O = "itemList__bullet-text", R = "itemList__title", S = "itemList__title--link", A = "itemList__description", M = "itemList__icon", U = "itemList--ordered", e = {
  itemList: I,
  itemListContent: g,
  itemListContainer: x,
  itemListHeading: C,
  itemListItems: k,
  itemListItem: b,
  itemListDefinition: D,
  itemListItemContent: v,
  itemListBullet: T,
  itemListUnordered: h,
  itemListBulletBox: H,
  itemListBulletDiamond: P,
  itemListBulletText: O,
  itemListTitle: R,
  itemListTitleLink: S,
  itemListDescription: A,
  itemListIcon: M,
  itemListOrdered: U
};
function w({
  id: r,
  title: o,
  listType: n,
  items: L,
  className: c
}) {
  const d = () => {
    const i = {
      ordered: e.itemListOrdered,
      unordered: e.itemListUnordered,
      definition: e.itemListDefinition
    };
    return (0,app_a75c1d35.c)(e.itemListContainer, i[n]);
  }, u = (i) => n === "ordered" ? /* @__PURE__ */ react.createElement("div", { className: e.itemListBullet }, /* @__PURE__ */ react.createElement("div", { className: e.itemListBulletBox }, /* @__PURE__ */ react.createElement("span", { className: e.itemListBulletText }, i + 1))) : n === "unordered" ? /* @__PURE__ */ react.createElement("div", { className: e.itemListBullet }, /* @__PURE__ */ react.createElement("div", { className: e.itemListBulletDiamond })) : null, l = () => {
    const i = e.itemListTitle;
    return n === "definition" ? (0,app_a75c1d35.c)(i, app_a75c1d35.t.textsParagraphSubtitleBold) : (0,app_a75c1d35.c)(i, app_a75c1d35.t.textsParagraphSubtitle);
  }, _ = (i) => /* @__PURE__ */ react.createElement(react.Fragment, null, i.linkHref ? /* @__PURE__ */ react.createElement(
    Link_479ac100.L,
    {
      href: i.linkHref,
      target: i.isExternalLink ? "_blank" : void 0,
      className: (0,app_a75c1d35.c)(
        l(),
        e.itemListTitleLink
      )
    },
    i.title,
    /* @__PURE__ */ react.createElement(
      Icon_3122c134.I,
      {
        icon: Icon_3122c134.W.ARROW_RIGHT,
        className: e.itemListIcon
      }
    )
  ) : n === "definition" ? /* @__PURE__ */ react.createElement("h3", { className: l() }, i.title) : /* @__PURE__ */ react.createElement("div", { className: l() }, i.title), i.description && /* @__PURE__ */ react.createElement(
    "p",
    {
      className: (0,app_a75c1d35.c)(
        e.itemListDescription,
        app_a75c1d35.t.textsBodyText
      )
    },
    i.description
  )), f = n === "ordered" ? "ol" : "ul";
  return /* @__PURE__ */ react.createElement(
    Block_9b78bd10.B,
    {
      id: r,
      as: "section",
      topPadding: Block_9b78bd10.B.Padding.SMALL,
      bottomPadding: Block_9b78bd10.B.Padding.SMALL,
      className: (0,app_a75c1d35.c)(e.itemList, c),
      "data-testid": "item-list"
    },
    /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { flex: !0, className: e.itemListContent }, /* @__PURE__ */ react.createElement("div", { className: d() }, o && /* @__PURE__ */ react.createElement(
      "h2",
      {
        className: (0,app_a75c1d35.c)(
          e.itemListHeading
        )
      },
      o
    ), /* @__PURE__ */ react.createElement(f, { className: e.itemListItems }, L.map((i, B) => /* @__PURE__ */ react.createElement("li", { key: i.id, className: e.itemListItem }, u(B), /* @__PURE__ */ react.createElement("div", { className: e.itemListItemContent }, _(i)))))))
  );
}

//# sourceMappingURL=ItemList.js.map

// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(8038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/service/schemaOrg/generators/itemList.ts

/**
 * Strips HTML tags and converts newlines to spaces for schema
 */ function stripHtmlAndNormalizeText(text) {
    // Remove HTML tags if any
    var cleaned = text.replace(/<[^>]*>/g, "");
    // Convert newlines to spaces
    cleaned = cleaned.replace(/\n+/g, " ");
    // Normalize multiple spaces to single space
    cleaned = cleaned.replace(/\s+/g, " ");
    // Trim whitespace
    return cleaned.trim();
}
/**
 * Extracts the first URL from a text string if present
 */ function extractFirstUrl(text) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    var match = urlRegex.exec(text);
    return match ? match[1] : undefined;
}
/**
 * Generates ItemList schema from list items
 * 
 * @param items - Array of list items with title, description, and optional link
 * @param title - Optional title for the list
 * @param description - Optional description/intro text for the list
 * @param locale - Language code for inLanguage property
 * @returns ItemList schema object with @context
 */ function generateItemListSchema(items, title, description) {
    var locale = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "en";
    var itemListElement = items.map(function(item, index) {
        var element = {
            "@type": "ListItem",
            position: index + 1,
            name: stripHtmlAndNormalizeText(item.title)
        };
        if (item.description) {
            element.description = stripHtmlAndNormalizeText(item.description);
            // If description contains URLs and no explicit link is provided, use the first URL
            if (!item.link) {
                var extractedUrl = extractFirstUrl(item.description);
                if (extractedUrl) {
                    element.url = extractedUrl;
                }
            }
        }
        // Explicit link takes precedence
        if (item.link) {
            element.url = item.link;
        }
        return element;
    });
    var schema = {
        "@type": "ItemList",
        itemListElement: itemListElement,
        inLanguage: locale
    };
    if (title) {
        schema.name = stripHtmlAndNormalizeText(title);
    }
    if (description) {
        schema.description = stripHtmlAndNormalizeText(description);
    }
    return (0,_object_spread/* default */.Z)({
        "@context": "https://schema.org"
    }, schema);
}
/**
 * Generates HowTo schema from list items (for step-by-step guides)
 * 
 * @param items - Array of list items representing steps
 * @param title - Title for the how-to guide
 * @param description - Optional description/intro text
 * @param locale - Language code for inLanguage property
 * @returns HowTo schema object with @context
 */ function generateHowToSchema(items, title, description) {
    var locale = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "en";
    var steps = items.map(function(item, index) {
        var step = {
            "@type": "HowToStep",
            position: index + 1,
            name: stripHtmlAndNormalizeText(item.title)
        };
        if (item.description) {
            // For HowTo, use the first line or sentence as the instruction
            var cleanedDescription = stripHtmlAndNormalizeText(item.description);
            var firstSentence = cleanedDescription.split(/[.!?]/)[0];
            step.text = firstSentence ? firstSentence.trim() + "." : cleanedDescription;
        }
        if (item.link) {
            step.url = item.link;
        }
        return step;
    });
    var schema = {
        "@type": "HowTo",
        step: steps,
        inLanguage: locale
    };
    if (title) {
        schema.name = stripHtmlAndNormalizeText(title);
    }
    if (description) {
        schema.description = stripHtmlAndNormalizeText(description);
    }
    return (0,_object_spread/* default */.Z)({
        "@context": "https://schema.org"
    }, schema);
}

// EXTERNAL MODULE: ./src/components/HtmlParser/HtmlParser.tsx + 2 modules
var HtmlParser = __webpack_require__(8940);
;// CONCATENATED MODULE: ./src/magnolia/components/ItemList/ItemList.tsx










function ItemList(props) {
    var locale = (0,router.useRouter)().locale;
    var isPreview = (0,router.useRouter)().isPreview;
    var items = (0,react.useMemo)(function() {
        return (0,magnolia/* jcrMultiFieldToArray */.FE)(props.items).map(function(item) {
            return {
                id: item["@id"],
                title: item.title,
                description: item.description,
                linkHref: (0,magnolia/* resolveLinkSwitchableField */.cJ)(item.link, isPreview).linkHref,
                isExternalLink: (0,magnolia/* resolveLinkSwitchableField */.cJ)(item.link, isPreview).isExternalLink
            };
        });
    }, [
        props.items,
        isPreview
    ]);
    if (items.length === 0) return null;
    // Generate schema based on schemaType
    var schema = null;
    if (props.schemaType === "itemList") {
        schema = generateItemListSchema(items, props.title, undefined, locale || "en");
    } else if (props.schemaType === "howTo") {
        schema = generateHowToSchema(items, props.title, undefined, locale || "en");
    }
    var itemsProcessed = items.map(function(item) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
            description: item.description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlParser/* HtmlParser */._, {
                html: item.description
            }) : undefined
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            schema && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    nonce: "5274deac-df2c-4405-9816-123c1b001d19",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(schema)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(w, {
                id: props.anchorTag,
                title: props.title,
                listType: props.listType,
                schemaType: props.schemaType,
                items: itemsProcessed
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/ItemList/index.ts



/***/ })

}]);